export default "__VITE_ASSET__CViHGTjL__"